export const formatDateYMD = (d: Date): string => {
	const y = d.getFullYear()
	const m = String(d.getMonth() + 1).padStart(2, '0')
	const day = String(d.getDate()).padStart(2, '0')
	return `${y}-${m}-${day}`
}

export const formatDateToDisplay = (dateStr: string) => {
	const parsedDate = parseStringToDateForDisplay(dateStr)

	if (!parsedDate) {
		return ''
	}

	return parsedDate.toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		timeZone: 'UTC',
	})
}

export const formatDate = (dateStr: string) =>
	new Date(dateStr).toLocaleDateString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	})

export function parseStringToDateForDisplay(dateStr: string): Date | undefined {
	if (!dateStr) return undefined
	// treat plain YYYY-MM-DD as local date (ignore timezone offset)
	const isoDateOnly = /^\d{4}-\d{2}-\d{2}$/
	if (isoDateOnly.test(dateStr)) {
		const [year, month, day] = dateStr.split('-').map(Number)
		return new Date(year, month - 1, day)
	}
	// try using Date constructor for ISO/timestamp
	const d = new Date(dateStr)
	if (!Number.isNaN(d.getTime())) {
		// if there is a time component, take the UTC date parts
		if (dateStr.includes('T') || dateStr.endsWith('Z')) {
			return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())
		}
		return new Date(d.getFullYear(), d.getMonth(), d.getDate())
	}
	// fallback dd/mm/yyyy
	const [day, month, year] = dateStr.split('/').map(Number)
	if (!day || !month || !year) return undefined
	return new Date(year, month - 1, day)
}

// 2026-03-26 => Thu Mar 26 2026 00:00:00 GMT-0300
export function parseLocalDate(isoDate: string) {
	const [year, month, day] = isoDate.split('-').map(Number)
	return new Date(year, month - 1, day)
}

export const dateOptions = [
	{
		value: 'ALL',
		label: 'Todas as datas',
	},
	{
		value: 'TODAY',
		label: 'Hoje',
	},
	{
		value: 'WEEK',
		label: 'Última semana',
	},
	{
		value: 'MONTH',
		label: 'Último mês',
	},
]
